<template>
  <div id="App" v-loading="false">
    <!-- <Index></Index> -->
    <router-view></router-view>
  </div>
</template>


<script>
import Index from "./pages/Index.vue";

export default {
  name: "App",
  components: {
    Index,
  },
  data() {
    return {
      loading: true,
    };
  },
  beforeCreate: function () {
    document.getElementsByTagName("body")[0].className = "bo";
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  },
};
</script>

<style lang="scss">
body {
  /* font-family: 幼圆, ”宋体”; */
  font-family: "Alibaba_PuhuiTi_45", ”宋体”;
  
}
#app {
  
  height: 100%;
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-items: center; */
}
.bo {
  margin: 0;
  
}
</style>
